const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/hero', {
  title: 'Hero',
  description: 'Componente com informações sobre a página',
  icon: 'layout',
  attributes,

  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
